var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2054_87098",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2054_87098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 20C11.0278 20 10.1171 19.819 9.26806 19.4571C8.41898 19.0952 7.68009 18.6063 7.05139 17.9905C6.42269 17.3746 5.92361 16.6508 5.55417 15.819C5.18472 14.9873 5 14.0952 5 13.1429C5 12.1905 5.18472 11.2984 5.55417 10.4667C5.92361 9.63492 6.42269 8.91111 7.05139 8.29524C7.68009 7.67937 8.41898 7.19048 9.26806 6.82857C10.1171 6.46667 11.0278 6.28571 12 6.28571H12.1167L10.9111 5.10476L12 4L15.1111 7.04762L12 10.0952L10.9111 8.99048L12.1167 7.80952H12C10.4833 7.80952 9.19676 8.32698 8.14028 9.3619C7.0838 10.3968 6.55556 11.6571 6.55556 13.1429C6.55556 14.6286 7.0838 15.8889 8.14028 16.9238C9.19676 17.9587 10.4833 18.4762 12 18.4762C13.5167 18.4762 14.8032 17.9587 15.8597 16.9238C16.9162 15.8889 17.4444 14.6286 17.4444 13.1429H19C19 14.0952 18.8153 14.9873 18.4458 15.819C18.0764 16.6508 17.5773 17.3746 16.9486 17.9905C16.3199 18.6063 15.581 19.0952 14.7319 19.4571C13.8829 19.819 12.9722 20 12 20Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circle-arrow.33c8af4f5d3f506b4cf4d2cd89dde5aa.svg";
export { ForwardRef as ReactComponent };